import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Smart_dubbing",
  "use": "icon-Smart_dubbing-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-Smart_dubbing\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M19,5V9.67H17.44V6.56H14.33V5ZM9.67,5V6.56H6.56V9.67H5V5Zm6.22,4.67v4.66H14.33V9.67Zm-6.22,0v4.66H8.11V9.67Zm3.11-2.34v9.34H11.22V7.33Zm6.22,7V19H14.33V17.44h3.11V14.33Zm-12.44,0v3.11H9.67V19H5V14.33Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol